import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { NOTIFY_RECIPIENT_SCREEN_SHOWN, SHARE_DETAILS_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { CATEGORY_TRANSFER_TO_CASH_UNITELLER } from 'apps/auth/constants/Constants';
import { MEXICO, NIGERIA, PHILIPPINES, VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { canShareDetails, copyTextToClipboard, shareDetails } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { VIETCOMBANK } from 'apps/auth/services/DisclaimerService';

const CashPayoutSecretCodeModal = (props) => {
    const {
        shareTitleDetails,
        notifyHeader,
        unitellerCashPickupCodeTitle,
        unitellerCashPickupLocationTitle,
        unitellerPickUpGuidLink,
        interacNotifySubheader,
        cashPayoutNotifyCodeLabel,
        interacNotifyCopyCode,
        cashPickupHeader,
        cashPayoutUrlLabel,
        homeDeliveryLabel,
        shareDetailsLink,
        copied,
    } = usePageMessages();

    const cheque = props.cheque;

    useEffect(() => {
        if (__isBrowser__) {
            props.sendEvent?.(NOTIFY_RECIPIENT_SCREEN_SHOWN);
        }
    }, [cheque]);

    const copyButtonClick = (textToCopy, messageSnackBar) => {
        return () => {
            const result = copyTextToClipboard(textToCopy);
            if (result) {
                props.toggleSnackBar(true, messageSnackBar);
            }
        };
    };

    const getUrl = (addProtocol = false) => {
        let url = (addProtocol ? location?.protocol + '//' : '') + location?.hostname + (location?.port ? ':' + location?.port : '');
        if (cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) {
            url = unitellerPickUpGuidLink;
        } else if (cheque.toCountryId === NIGERIA) {
            url += '/cash-pickup-in-nigeria';
        } else if (cheque.toCountryId === PHILIPPINES) {
            url += '/cash-pickup-in-philippines';
        } else if (cheque.toCountryId === VIETNAM) {
            if (cheque.toBankName === VIETCOMBANK) {
                url += '/cash-pickup-in-vietcombank';
            } else if (cheque.toHomeDelivery) {
                url += '/home-delivery-in-vietnam';
            } else {
                url += '/cash-pickup-in-vietnamese-banks';
            }
        } else if (cheque.toCountryId === MEXICO) {
            url += '/cash-pickup-in-mexico';
        }
        return url;
    };

    const getMessageForSnackBar = (title, copied) => `${title} ${copied}`;

    return (
        <ModalComponent>
            <HeaderPanel title={notifyHeader} subtitle={interacNotifySubheader} />
            {(cheque.toCountryId !== VIETNAM || cheque.toBankName === VIETCOMBANK) && (
                <Row indent="adaptive-32-48">
                    <DetailsItem
                        detailsTitle={
                            cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER ? unitellerCashPickupCodeTitle : cashPayoutNotifyCodeLabel
                        }
                        detailsText={cheque.secretCode}
                        detailsButton={interacNotifyCopyCode}
                        detailsButtonClick={copyButtonClick(cheque.secretCode, getMessageForSnackBar(cashPayoutNotifyCodeLabel, copied))}
                    />
                </Row>
            )}
            {(cheque.toCountryId === PHILIPPINES || cheque.toCountryId === MEXICO || cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) && (
                <Row indent="adaptive-32-48">
                    <DetailsItem
                        detailsTitle={cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER ? unitellerCashPickupLocationTitle : cashPickupHeader}
                        detailsText={cheque.toBankName}
                        detailsButton={interacNotifyCopyCode}
                        detailsButtonClick={copyButtonClick(cheque.toBankName, getMessageForSnackBar(cashPickupHeader, copied))}
                    />
                </Row>
            )}
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={cheque.toHomeDelivery ? homeDeliveryLabel : cashPayoutUrlLabel}
                    detailsText={getUrl()}
                    detailsButton={interacNotifyCopyCode}
                    detailsButtonClick={copyButtonClick(
                        getUrl(true),
                        getMessageForSnackBar(cheque.toHomeDelivery ? homeDeliveryLabel : cashPayoutUrlLabel, copied),
                    )}
                />
            </Row>
            {canShareDetails() && (
                <Button
                    type="button"
                    variant="row"
                    size="tight"
                    caption={shareDetailsLink}
                    negativeMargin
                    onClick={(e) => {
                        e.preventDefault();
                        amplitude.getInstance().logEvent(SHARE_DETAILS_CLICKED);
                        shareDetails(`${shareTitleDetails}`, `${cheque.shareDetails}`);
                    }}
                />
            )}
        </ModalComponent>
    );
};

export default connect(null, { toggleSnackBar })(CashPayoutSecretCodeModal);
